export function setAndSendPageview(window, page) {
    window.ga('set', 'page', page);
    window.ga('send', 'pageview');
}



// WEBPACK FOOTER //
// ./src/utils/googleAnalytics/index.js